
document.addEventListener("DOMContentLoaded", function() {
    let priceValue = 0; 
    function updatePrice() {
        const priceElement = document.querySelector('sale-price .money');
        if (priceElement) {
            const priceText = priceElement.textContent.replace('$', '').trim();
            priceValue = parseFloat(priceText);
            updateTotal();
        }
    }

    function updateQuantity() {
        const quantityInput = document.querySelector('.quantity-selector__input');
        if (quantityInput) {
            const quantityValue = parseFloat(quantityInput.value) || 0;
            updateTotal();
        }
    }
    function updateTotal() {
        const quantityInput = document.querySelector('.quantity-selector__input');
        const freeDeliveryMessage = document.getElementById('free-delivery-message');
        const detectedCity = document.getElementById('detected-city');

        if (quantityInput) {
            const quantityValue = parseFloat(quantityInput.value) || 0;
            const totalValue = priceValue * quantityValue;
            console.log('Total (precio * cantidad):', totalValue);
            if (totalValue > 75 && detectedCity.textContent && false) { // Client requested it be gone 3/5/2026 - DTWD
                freeDeliveryMessage.style.display = 'block';
            } else {
                freeDeliveryMessage.style.display = 'none';
            }
        }
    }
    updatePrice();
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                updatePrice();
            }
        });
    });
    const targetNode = document.querySelector('sale-price');
    if (targetNode) {
        observer.observe(targetNode, { childList: true, characterData: true, subtree: true });
    }
    const quantityInput = document.querySelector('.quantity-selector__input');
    const decreaseButton = document.querySelector('.quantity-selector__button[aria-label="Decrease quantity"]');
    const increaseButton = document.querySelector('.quantity-selector__button[aria-label="Increase quantity"]');

    function handleQuantityChange() {
        updateQuantity();
    }

    quantityInput.addEventListener('input', handleQuantityChange);
    function increaseQuantity() {
        let currentValue = parseInt(quantityInput.value, 10);
        if (isNaN(currentValue)) currentValue = 1;
        quantityInput.value = currentValue + 0;
        handleQuantityChange();
    }

    function decreaseQuantity() {
        let currentValue = parseInt(quantityInput.value, 10);
        if (isNaN(currentValue)) currentValue = 0;
        if (currentValue > 0) {
            quantityInput.value = currentValue - 0; 
            handleQuantityChange();
        }
    }

    increaseButton.addEventListener('click', increaseQuantity);
    decreaseButton.addEventListener('click', decreaseQuantity);
    handleQuantityChange();
    function fetchGeolocation() {
        fetch('https://ipapi.co/json/')
            .then(response => response.json())
            .then(data => {
                if (data.country_code === 'US') {
                    document.getElementById('detected-city').textContent = data.region;
                    updateTotal(); 
                } else {
                    document.getElementById('free-delivery-message').style.display = 'none';
                }
            })
            .catch(error => {
                console.error('Error fetching geolocation:', error);
            });
    }

    fetchGeolocation();
});